<template>
  <span style="cursor:pointer">
  <v-img
    v-responsive="largeSize"
    position="top center"
    :src="(item.media && item.media.md_2) || item.image_2"
    aspect-ratio="2.8"
    @mouseup="mouseup(item)"
    @mousedown="mousedown"></v-img>
  <v-img
    v-responsive="middleSize"
    position="top center"
    :src="(item.media && item.media.sm_2) || item.image_2"
    aspect-ratio="2.8"
    @mouseup="mouseup(item)"
    @mousedown="mousedown"></v-img>
  <v-img
    v-responsive="smallSize"
    position="top center"
    :src="(item.media && item.media.sm) || item.image"
    aspect-ratio="1.79"
    @mouseup="mouseup(item)"
    @mousedown="mousedown"></v-img>
  </span>
</template>

<script>
import { mapActions } from 'vuex'
import vueResponsive from 'vue-responsive'
export default {
  data: () => ({
    largeSize: ['hidden-all', 'lg', 'xl'],
    middleSize: ['hidden-all', 'md'],
    smallSize: ['hidden-all','xs', 'sm'],
    t: 0
  }),
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
  },
  methods: {
    ...mapActions(['logBanner']),
    async openBanner (banner) {
      this.logBanner(banner.id)
      if (banner.action_type === 'url') {
        const pre = banner.url.indexOf('http') === 0 ? '': 'https://'
        window.open(pre + banner.url, '_blank')
      } else if (banner.action_type === 'program') {
        const program = await banner.program_ref.get()
        this.$router.push({ name: 'Program', params: { slug: program.data()   .slug } })
      } else if (banner.action_type === 'login') {
        this.$router.push({ path: 'sanvalentin' })
      }
    },
    mouseup (banner) {
      if (Date.now() - this.t < 100) {
        this.openBanner(banner)
      }
    },
    mousedown () {
      this.t = Date.now()
    }
  },
  mounted () {
    console.log('Banner:', this.item)
  },
  directives: {
    responsive: vueResponsive
  }
}
</script>

<style>

</style>
